export default {
  config: {
    app: 'RouletteWeb',
    gateway: {},
    locale: 'en',
    timezoneOffset: 0,
    wheel: null,
  },
  translations: {
    roundTitle: 'Round',
    roundResultsTitle: 'Roulette Results',
    winningNumberTitle: 'Winning number',
    winningBetsTitle: 'Winning bets',
  },
  results: {
    rounds: [],
    pagination: null,
  },
};
